import React from 'react';

const PageLoadError = () => {
    return <div className="m-3">We are unable to retrieve your information at this time. Please try again later.</div>;
};

export default PageLoadError;
